import { Video } from "lucide-react";
import { useShallow } from "zustand/react/shallow";

import { buttonVariants } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { cn } from "@/lib/utils";

export function SelectCamera() {
  const vidyoSDK = useVidyoStore((state) => state.vidyoSDK);

  const cameras = useVidyoStore((state) => state.camera.available);
  const selectedCamera = useVidyoStore(
    useShallow((state) => ({
      id: state.camera.selected?.id,
      name: state.camera.selected?.name,
    })),
  );
  const setPreferredCamera = useVidyoStore(
    (state) => state.camera.setPreferred,
  );
  const handleSelectCamera = async (cameraId: string) => {
    const camera = cameras.find((c) => c.id === cameraId);
    if (camera) {
      await vidyoSDK?.SelectLocalCamera({
        localCamera: camera,
      });
      setPreferredCamera(camera);
    }
  };

  return (
    <Select value={selectedCamera?.id} onValueChange={handleSelectCamera}>
      <SelectTrigger
        className={cn(buttonVariants({ variant: "ghost" }), "justify-normal")}
        disabled={cameras.length === 0}
      >
        <Video className="mr-2 h-4 w-4 flex-shrink-0" />
        <span className="inline-block truncate">
          {cameras.length === 0
            ? "No camera(s) available"
            : (selectedCamera?.name ?? "Select Camera...")}
        </span>
      </SelectTrigger>
      <SelectContent>
        {cameras.map((camera) => (
          <SelectItem key={camera.id} value={camera.id}>
            {camera.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
